import * as React from 'react';

export function useFetchText(requestInfo?: RequestInfo): string | undefined {
  const [text, setText] = React.useState<string | undefined>();
  React.useEffect(() => {
    if (requestInfo) {
      fetch(requestInfo)
        .then(res => res.text())
        .then(setText);
    }
  }, [requestInfo, setText]);

  return text;
}
